import { useState, useEffect, useContext } from "react";
import "./style/Services.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "./auth/AuthProvider";
import { FaSpinner } from "react-icons/fa";
import RelifeContactNew from "./homeLayout/RelifeContactNew";
import RelifeFooter from "./homeLayout/RelifeFooter";
import axios from "axios";
import Payment from "../js_helper/usePayment.js";
import usePayment from "../js_helper/usePayment.js";
// import { loadStripe } from "@stripe/stripe-js";

const FEATURES = [
  "Full access to all 5 phases of a theme",
  "25 carefully crafted reflection questions",
  "Audio reflections built around your answers",
  "Structured emotional journey — not random prompts",
  "Progress saved locally — continue any time",
  "Private by design — nothing leaves your device",
];

export default function Services() {
  // const [servicePayment, setServicePayment] = useState(null);
  // const [urlExists, setUrlExists] = useState(false);

  const [loading, setLoading] = useState(true);
  const {
    // loading,
    // setLoading,
    authenticated,
    user,
    status,
    setStatus,
    paymentLocation,
    setPaymetLocation,
    payload,
    setPayload,
    setSessionId,
    sessionId,
    payed,
    prevLocation,
    storage,
    googleUser,
    apiUrl,
    setError,
    setPrevLocation,
    // setPayedStressFatigue,
    // payedStressFatigue,
  } = useContext(AuthContext);

  const { handlePayment } = usePayment();

  const [slug, setSlug] = useState("");
  const [theme, setTheme] = useState([]);

  const [payedLove, setPayedLove] = useState(false);
  const [payedStress, setPayedStress] = useState(false);
  const [payedMotivation, setPayedMotivation] = useState(false);

  const [showInfo, setShowInfo] = useState({
    id: 0,
    show: false,
  });

  const navigate = useNavigate();

  const location = useLocation();

  const { id } = useParams();
  useEffect(() => {
    axios
      .get(`${apiUrl}/theme`)
      .then((response) => {
        setTheme(response.data.sort((a, b) => a.id - b.id));
      })
      .catch((e) => {
        console.error(e);

        setError(e.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    // localStorage.setItem("postLoginRedirectTheme", prevLocation);

    if (!user && !googleUser) {
      // localStorage.setItem("postLoginRedirectTheme", prevLocation);
      localStorage.setItem("postLoginRedirect", location.pathname);
      return;
    }

    async function getInfo() {
      setLoading(true);
      const currentUser = user
        ? `success/username/${user.username}`
        : `success/googleEmail/${encodeURIComponent(googleUser.email)}`;
      try {
        const [
          // themeData,
          successDataLove,
          successDataStress,
          successDataMotivation,
        ] = await Promise.allSettled([
          // axios.get(`${apiUrl}/theme`),
          axios.get(`${apiUrl}/${currentUser}/love-and-disappointment`),
          axios.get(`${apiUrl}/${currentUser}/stress-and-fatigue`),
          axios.get(`${apiUrl}/${currentUser}/motivation-and-laziness`),
        ]);

        if (successDataLove.value.data.length > 0) {
          setPayedLove(true);
        }
        if (successDataStress.value.data.length > 0) {
          setPayedStress(true);
        }
        if (successDataMotivation.value.data.length > 0) {
          setPayedMotivation(true);
        }
      } catch (error) {
        // console.log("Error: ");
      } finally {
        setLoading(false);
      }
    }

    getInfo();
  }, [user, googleUser, payed, id, paymentLocation, navigate, setPrevLocation]);

  if (loading) {
    return (
      <div className="spinner-wrapper">
        <FaSpinner className="spin" size={40} />
      </div>
    );
  }

  function handleShow(id) {
    setShowInfo((prevState) => ({
      ...prevState,
      id: id,
      show: !prevState.show,
    }));
  }

  return (
    <>
      <div
        className="pricing-page"
        // style={{ backgroundColor: "rgb(255, 171, 141)" }}
      >
        <div
          className="pricing-header"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.65 }}
        >
          <div className="pricing-rule" />
          <span className="pricing-eyebrow">Simple, honest pricing</span>
          <h1 className="pricing-headline">Pay once. Reflect deeply.</h1>
          <p className="pricing-sub">
            No subscriptions. No recurring charges. One theme, one honest
            investment in understanding yourself more clearly.
          </p>
        </div>
        <section className="services">
          {theme.map((t) =>
            t.id === 1 ? (
              payedLove === false ? (
                <div key={t.id}>
                  <>
                    <div className="service-card">
                      <h2>{t.title}</h2>
                      <h2 className="pricing-card-name">Full Theme Access</h2>
                      <p className="pricing-card-desc">
                        Complete guided reflection journey — 5 phases, 25
                        questions, calm audio insights built around your
                        answers.
                      </p>

                      <div className="pricing-amount">
                        <div className="pricing-price">€4.99</div>
                      </div>
                      <div className="pricing-amount">
                        <div className="pricing-price-note">
                          one-time per theme
                        </div>

                        <>
                          <div className="pricing-card-features">
                            <ul className="pricing-feature-list">
                              {FEATURES.map((f) => (
                                <li key={f} className="pricing-feature">
                                  <span className="pricing-feature-dot" />
                                  {f}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </>

                        <button
                          id="pricing-cta"
                          className="pricing-cta"
                          onClick={() => {
                            handlePayment(
                              user,
                              googleUser,
                              "love-and-disappointment",
                              "Love & Disappointment",
                            );
                          }}
                        >
                          Unlock Full Access ($4.99)
                        </button>
                      </div>
                    </div>
                  </>
                </div>
              ) : (
                <div key={t.id} style={{ display: "none" }}></div>
              )
            ) : t.id === 2 ? (
              payedStress === false ? (
                <div key={t.id}>
                  <>
                    <div className="service-card">
                      <h2>{t.title}</h2>
                      <h2 className="pricing-card-name">Full Theme Access</h2>
                      <p className="pricing-card-desc">
                        Complete guided reflection journey — 5 phases, 25
                        questions, calm audio insights built around your
                        answers.
                      </p>

                      <div className="pricing-amount">
                        <div className="pricing-price">€4.99</div>
                      </div>
                      <div className="pricing-amount">
                        <div className="pricing-price-note">
                          one-time per theme
                        </div>
                        <div className="pricing-card-features">
                          <ul className="pricing-feature-list">
                            {FEATURES.map((f) => (
                              <li key={f} className="pricing-feature">
                                <span className="pricing-feature-dot" />
                                {f}
                              </li>
                            ))}
                          </ul>
                        </div>
                        <button
                          id="pricing-cta"
                          className="pricing-cta"
                          onClick={() => {
                            handlePayment(
                              user,
                              googleUser,
                              "stress-and-fatigue",
                              "Stress & Fatigue",
                            );
                          }}
                        >
                          Unlock Full Access ($4.99)
                        </button>
                      </div>
                    </div>
                  </>
                </div>
              ) : (
                <div key={t.id} style={{ display: "none" }}></div>
              )
            ) : t.id === 3 ? (
              payedMotivation === false ? (
                <div key={t.id}>
                  <>
                    <div className="service-card">
                      <h2>{t.title}</h2>
                      <h2 className="pricing-card-name">Full Theme Access</h2>
                      <p className="pricing-card-desc">
                        Complete guided reflection journey — 5 phases, 25
                        questions, calm audio insights built around your
                        answers.
                      </p>

                      <div className="pricing-amount">
                        <div className="pricing-price">€4.99</div>
                      </div>
                      <div className="pricing-amount">
                        <div className="pricing-price-note">
                          one-time per theme
                        </div>
                        <div className="pricing-card-features">
                          <ul className="pricing-feature-list">
                            {FEATURES.map((f) => (
                              <li key={f} className="pricing-feature">
                                <span className="pricing-feature-dot" />
                                {f}
                              </li>
                            ))}
                          </ul>
                        </div>
                        <button
                          id="pricing-cta"
                          className="pricing-cta"
                          onClick={() => {
                            handlePayment(
                              user,
                              googleUser,
                              "motivation-and-procrastination",
                              "Motivation & Procrastination",
                            );
                          }}
                        >
                          Unlock Full Access ($4.99)
                        </button>
                      </div>
                    </div>
                  </>
                </div>
              ) : (
                <div key={t.id} style={{ display: "none" }}></div>
              )
            ) : (
              // <>
              <div className="service-card sc" key={t.id}>
                <h2>{t.title}</h2>
                <p className="cs">Coming soon.</p>
                <h2 className="pricing-card-name">Full Theme Access</h2>
                <p className="pricing-card-desc">
                  Complete guided reflection journey — 5 phases, 25 questions,
                  calm audio insights built around your answers.
                </p>

                <div className="pricing-amount">
                  <div className="pricing-price">€4.99</div>
                </div>
                <div className="pricing-amount">
                  <div className="pricing-price-note">one-time per theme</div>

                  <div className="pricing-card-features">
                    <ul className="pricing-feature-list">
                      {FEATURES.map((f) => (
                        <li key={f} className="pricing-feature">
                          <span className="pricing-feature-dot" />
                          {f}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <button
                    id="pricing-cta"
                    className="pricing-cta"
                    onClick={() => {
                      handlePayment(
                        user,
                        googleUser,
                        "love-and-disappointment",
                        "Love & Disappointment",
                      );
                    }}
                    disabled
                  >
                    Unlock Full Access ($4.99)
                  </button>
                </div>
              </div>
              // </>
            ),
          )}
        </section>
      </div>

      <RelifeContactNew />
    </>
  );
}
